import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { deal: data } = await sdk.getOneDeal({
    id,
  });
  return { data };
}

export const dealNotes = types.dataProvider({
  getOne,
});
